import Vue from 'vue';
const Babyform = {
    religion: "",
    gender: "",
    startsWith: "",
    maxChars: null,
    rows: 10,
    page: 1,
    url: window.immiObj.action,
    sortBy: 'name',
    sortType: 'Asc'
};
export let babyNamesMixin = {
    data () {
        return {
            form: {
                ...Babyform
            }
        }
    },
    created () {
        if (window.immiObj.babyNames) {
            this.form.religion = window.immiObj.babyNames.religion ? window.immiObj.babyNames.religion === "Hindu" ? 'h' : window.immiObj.babyNames.religion === "Muslim" ? 'm' : "" : "";
            this.form.gender = window.immiObj.babyNames.gender || "";
            this.form.startsWith = window.immiObj.babyNames.startsWith || "";
            this.form.maxChars = window.immiObj.babyNames.maxCharacters || null;
            this.form.url = window.immiObj.babyNames.page > 1 ? `${window.immiObj.action}${window.immiObj.babyNames.page}/` : window.immiObj.action;
            this.form.rows = window.immiObj.babyNames.totalRows || 10;
            this.form.sortBy = window.immiObj.babyNames.sortBy || 'name';
            this.form.sortType = window.immiObj.babyNames.sortType || 'Asc';
        }
    },
    methods: {
        submitSearch () {
            this.form.page = 1;
            this.form.url = window.immiObj.action;
            Vue.nextTick(() => $("#searchForm").submit());
        },
        navigateAndSet (url, page) {
            this.form.page = page;
            this.form.url = page > 1 ? `${window.immiObj.action}${page}/` : window.immiObj.action;
            Vue.nextTick(() => $("#searchForm").submit());
        },
        changeRows () {
            this.submitSearch();
        },
        triggerSortBy () {
            this.form.sortType = this.form.sortType === 'Asc' ? 'Dsc' : 'Asc';
            this.submitSearch();
        }
    }
}